import { z } from "zod";

export const SalesPaymentEnrichSchema = z
  .object({
    statement_id: z.string().uuid().optional(),
    from: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, "from must be YYYY-MM-DD")
      .optional(),
    to: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, "to must be YYYY-MM-DD")
      .optional(),
    overwrite: z.boolean().default(false),
  })
  .refine(
    (d) =>
      d.statement_id !== undefined ||
      (d.from !== undefined && d.to !== undefined),
    { message: "Provide statement_id or both from and to" }
  );

export type SalesPaymentEnrichRequest = z.infer<typeof SalesPaymentEnrichSchema>;

export interface SalesEnrichResult {
  repaired: number;
  enriched: number;
  paid: number;
  partially_paid: number;
  overdue: number;
  waiting: number;
  unconfirmed: number;
  skipped: number;
  errors: string[];
}
